import('./page/PageBuilder/lazyInit').then((module) => module.renderWebComponent());
export {};
